const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/$orgNumber/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/")({
  loader: async ({
    params
  }) => {
    const {
      orgNumber
    } = params;
    const res = await routeLoaderApiClient.superuser.organisation[":orgNumber"].$get({
      param: {
        orgNumber
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch messages");
    }
    return {
      organisation: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Superuser AFPANT | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});